import React, { useState, useEffect } from 'react';
import { Link  } from 'react-router-dom';
import axiosInstance from '../../Services/AxiosAPICaller';
import { ILinkGroups } from '../../Interfaces/ILinkGroups';
import './LinkGroupGetter.css';

interface LinkGroupProps {
  BulleId?:  number | null;
}

const LinkGroupGetter: React.FC<LinkGroupProps> = ({ BulleId }) => {

  const [LinkGroups, setLinkGroup] = useState<ILinkGroups[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => 
    {
      // Remplacez l'URL par l'endpoint réel de votre API
      axiosInstance.get< { data: { id: number, attributes: any }[]}>(`/groupe-de-liens?populate[bulle][fields][0]=Id&filters[bulle][id]=${BulleId}`)
      .then(response => 
        {
          // check if returned data is an array
          if (Array.isArray(response.data.data))
          {
          
            // Create LinkGroup Object From API returned Datas
            const LinkGroup = response.data.data.map(item => (
              {
                Id: item.id,
                Name:item.attributes.Nom,
                Description: item.attributes.Description,
                Image: item.attributes.Image,
                Bubble: item.attributes.bulle, 
                Links: item.attributes.liens_utiles ?? null 
              }));

              setLinkGroup(LinkGroup);
          } 
          else 
          {
            setError('La réponse de l\'API n\'est pas un tableau.');
            console.error('La réponse de l\'API n\'est pas un tableau.');
          }
      })
      .catch(error => {
        console.error('Erreur lors de la récupération des objets :', error);
      });
    }, [BulleId]);

    return (
      <div className="LinkGroupContainer">
        {
          error && <p>{error}</p>
        }


      <p className='LinkTitle'> Liens utiles </p>

        {
          LinkGroups.length > 0 ? (
            LinkGroups.map(Lg => (
            <Link to={`/LinkGroup/${Lg.Id}`} key={Lg.Id} className={`LinkGroupBtn`}>{Lg.Name}
            </Link>
          ))
          ) : (
          <p>Aucuns groupes de Liens à afficher.</p>
        )
        }
      </div>
    );
}

export default LinkGroupGetter;